import request from "~/utils/http";

const dashboardApi =
{
    statistics: async (params) =>
    {
        const url = 'dashboard/statistics';
        return await request.get(url, { params });
    },
    sellers: async (params) =>
    {
        const url = 'dashboard/top-sellers';
        return await request.get(url, { params });
    },
    products: async (params) =>
    {
        const url = 'dashboard/top-products';
        return await request.get(url, { params });
    },
};

export default dashboardApi;
